import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-histogram",
  "use": "icon-histogram-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-histogram\"><rect x=\"2.5\" y=\"56.333\" width=\"17\" height=\"32\" /><rect x=\"28.5\" y=\"34.5\" width=\"17\" height=\"53.833\" /><rect x=\"54.5\" y=\"45.666\" width=\"17\" height=\"42.667\" /><rect x=\"80.5\" y=\"11.666\" width=\"17\" height=\"76.668\" /><text x=\"0\" y=\"115\" fill=\"#000000\" font-size=\"5px\" font-weight=\"bold\" font-family=\"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif\">Created by Srinivas Agra</text><text x=\"0\" y=\"120\" fill=\"#000000\" font-size=\"5px\" font-weight=\"bold\" font-family=\"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif\">from the Noun Project</text></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/histogram.svg
// module id = t+/1
// module chunks = 102